/**
 * @file: CustomerViewedReportBody.tsx
 *
 * `OrgCustomerViewedReport` — the car owner opened the report (proof
 * of engagement). One-line "{viewer} viewed {reportType}". `Customer`
 * and `Shared` opens are both the owner (differing only by entry
 * channel — template message vs the mini-program report share), so
 * both prefer the real customer name; the channel is surfaced as a
 * muted source row.
 */

import { ReportOpenUserType } from '@euler/model/enum/ReportOpenUserType';
import { OrgCustomerViewedReportFeedPayload } from '@euler/model/feed';
import { formatDateTime } from '@euler/utils/formatters/datetime';
import { FC } from 'react';
import { View } from 'react-native';
import {
  reportOpenChannelName,
  reportTypeName,
  reportViewerName,
} from './common/labels';
import { BodyText, TitleText } from './common/primitives';

const isCarOwner = (t: ReportOpenUserType): boolean =>
  t === ReportOpenUserType.Customer || t === ReportOpenUserType.Shared;

export const CustomerViewedReportBody: FC<{
  p: OrgCustomerViewedReportFeedPayload;
}> = ({ p }) => {
  const viewer = isCarOwner(p.userType)
    ? p.customerName ?? reportViewerName(p.userType)
    : reportViewerName(p.userType);
  const channel = reportOpenChannelName(p.userType);
  return (
    <View>
      <TitleText>
        {viewer} 查看了{reportTypeName(p.reportType)}
      </TitleText>
      {channel ? (
        <BodyText mt={6} color="#9ca3af">
          来源：{channel}
        </BodyText>
      ) : null}
      {p.viewedAt ? (
        <BodyText mt={channel ? 2 : 6} color="#9ca3af">
          查看时间：{formatDateTime(p.viewedAt)}
        </BodyText>
      ) : null}
    </View>
  );
};
